var _path, _path2, _path3, _circle, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 4.33333C12.6589 4.33333 13.3034 4.52883 13.8516 4.8951C14.3997 5.26137 14.827 5.78197 15.0793 6.39106C15.3316 7.00014 15.3976 7.67036 15.269 8.31697C15.1403 8.96357 14.8229 9.55751 14.3567 10.0237C13.8905 10.4899 13.2966 10.8073 12.65 10.936C12.0034 11.0646 11.3332 10.9986 10.7241 10.7463C10.115 10.494 9.59438 10.0667 9.22811 9.51857C8.86184 8.9704 8.66634 8.32594 8.66634 7.66667C8.66634 6.78261 9.01753 5.93477 9.64265 5.30964C10.2678 4.68452 11.1156 4.33333 11.9997 4.33333ZM11.9997 3C11.0767 3 10.1744 3.2737 9.40702 3.78648C8.63959 4.29926 8.04145 5.02809 7.68824 5.88081C7.33503 6.73353 7.24261 7.67184 7.42268 8.57709C7.60274 9.48233 8.0472 10.3139 8.69985 10.9665C9.35249 11.6191 10.184 12.0636 11.0893 12.2437C11.9945 12.4237 12.9328 12.3313 13.7855 11.9781C14.6383 11.6249 15.3671 11.0268 15.8799 10.2593C16.3926 9.4919 16.6663 8.58965 16.6663 7.66667C16.6663 6.42899 16.1747 5.242 15.2995 4.36683C14.4243 3.49167 13.2374 3 11.9997 3Z",
    fill: "#000C36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.6667H18.4V18.3334C18.4 17.4493 17.9786 16.6015 17.2284 15.9763C16.4783 15.3512 15.4609 15 14.4 15H9.6C8.53913 15 7.52172 15.3512 6.77157 15.9763C6.02143 16.6015 5.6 17.4493 5.6 18.3334V21.6667H4V18.3334C4 17.0957 4.59 15.9087 5.6402 15.0335C6.69041 14.1584 8.11479 13.6667 9.6 13.6667H14.4C15.8852 13.6667 17.3096 14.1584 18.3598 15.0335C19.41 15.9087 20 17.0957 20 18.3334V21.6667Z",
    fill: "#000C36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55566 20.1111H18.7779V21.6666H5.55566V20.1111Z",
    fill: "#000C36"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7776,
    cy: 7.66666,
    r: 3.88889,
    fill: "#000C36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19C5 16.2386 7.23858 14 10 14H14C16.7614 14 19 16.2386 19 19V21H5V19Z",
    fill: "#000C36"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/Name.330954e1.svg";
export { ForwardRef as ReactComponent };